import { OthersInformationBody, PatchOthersInformationBody, QueryOthersInformation, ResponseOthers } from "src/entity/others/information";
import http from "../utils/http-common";
import { AxiosResponse } from "axios";
import { FilterOthersFillEmission, FilterOthersReportVocsEmission, UpdateOthersFillEmission } from "src/entity/others/fill-emission";
import { SubmitReportVocBody } from "src/entity/common/global.entity";
import { CalculationMethodOthersEnum } from "src/entity/common/common.constant";

const base_other_paht = "/api/others";
const baseMasterPath = "/api/masterdata";

export const getMasterDataEmission = () => {
  return http.get(baseMasterPath, { params: { label: "Emission", type: "global" } });
};

export const getInformationDistinctYear = () => {
  return http.get(`${base_other_paht}/setup/year`);
};

// Others -> Information
export const createOthersInformation = (body: OthersInformationBody) => {
  return http.post(`${base_other_paht}/information`, body);
};

export const updateOthersInformation = (body: PatchOthersInformationBody) => {
  return http.patch(`${base_other_paht}/information`, body);
};

export const getOthersInformation = (
  params: QueryOthersInformation,
): Promise<AxiosResponse<{ data: { data: ResponseOthers[]; total: number } }>> => {
  return http.post(`${base_other_paht}/search/information`, params);
};

export const deleteOtherInformation = (_id: string) => {
  return http.delete(`${base_other_paht}/information/${_id}`);
};

export const getAllDistinctColumns = (params: { year: string }) => {
  return http.get(`${base_other_paht}/information/filter-column`, { params });
};

// Others Fill Emission
export const getAllFillEmission = (body: FilterOthersFillEmission) => {
  return http.post(`${base_other_paht}/search/fill-emission-others`, body);
};

export const updateOthersFillEmission = (_id: string, body: UpdateOthersFillEmission) => {
  return http.patch(`${base_other_paht}/fill-emission/${_id}`, body);
};

export const getAllDistinctColumnsFillEmission = (params: {
  year: string;
  calculationMethod?: CalculationMethodOthersEnum.FILL_EMISSION | CalculationMethodOthersEnum.STACK_SAMPLING;
}) => {
  return http.get(`${base_other_paht}/fill-emission/filter-column`, { params });
};

export const getAllReportVocEmission = (body: FilterOthersReportVocsEmission) => {
  return http.post(`${base_other_paht}/search/report-voc`, body);
};

// Others Approval

export const getOptionMonthSubmit = (year: string) => {
  return http.get(`${base_other_paht}/report/voc-emission/approve/month/${year}`);
};

export const submitReportVoc = (data: SubmitReportVocBody) => {
  return http.post(`${base_other_paht}/report/voc-emission/approve/submit-report`, data);
};

export const getInfoStepApprove = (approveId: string) => {
  return http.get(`${base_other_paht}/report/voc-emission/approve/info-step/${approveId}`);
};

export const getOptionVocApprove = () => {
  return http.get(`${base_other_paht}/report/voc-emission/approve/filter-voc-approve`);
};

export const updateApproveStep = (data: any) => {
  return http.patch(`${base_other_paht}/report/voc-emission/approve/approve-step`, data);
};
